import { BrowserRouter, MemoryRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "@/components/base/ScrollToTop";

type AppProps = {
  staticPath?: string;
};

function App({ staticPath }: AppProps) {
  const Router = staticPath ? MemoryRouter : BrowserRouter;
  const routerProps = staticPath
    ? { initialEntries: [staticPath] }
    : { basename: __BASE_PATH__ };

  return (
    <I18nextProvider i18n={i18n}>
      <Router {...routerProps}>
        <ScrollToTop />
        <AppRoutes />
      </Router>
    </I18nextProvider>
  );
}

export default App;